module.exports = __webpack_public_path__ + "static/media/Corn_Green.8d496c48.svg";